import { render, staticRenderFns } from "./top.vue?vue&type=template&id=cf20219c&scoped=true"
import script from "./top.vue?vue&type=script&lang=js"
export * from "./top.vue?vue&type=script&lang=js"
import style0 from "./top.vue?vue&type=style&index=0&id=cf20219c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf20219c",
  null
  
)

export default component.exports